import { useState } from "react";

import styled from "styled-components";
import { Form, Radio } from "antd";
// import { Space } from "antd";
import Select from "components/inputs/Select";

export default function DataController() {
  const [form] = Form.useForm();

  const [type, setType] = useState(1);

  return (
    <Container>
      <Form.Item
        name="select"
        style={{ marginTop: 24 }}
        valuePropName="checked"
      >
        <Radio.Group
          onChange={(e) => {
            setType(e.target.value);
          }}
          value={type}
          optionType="button"
          buttonStyle="solid"
        >
          <Radio value={1}>همه</Radio>
          <Radio value={2}>چند</Radio>
          <Radio value={3}>تکی</Radio>
        </Radio.Group>
      </Form.Item>
      <label>بر اساس :</label>
      <Form.Item
        name="filter"
        rules={[
          {
            required: true,
            message: "لطفا فیلتر را وارد کنید!",
          },
        ]}
      >
        <Select
          borderradius="0"
          list={list}
          showSearch
          placeholder="جستجو"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          filterSort={(optionA, optionB) =>
            optionA.children
              .toLowerCase()
              .localeCompare(optionB.children.toLowerCase())
          }
        />
      </Form.Item>
    </Container>
  );
}
const Container = styled.div``;
const Section = styled.div``;

const list = [
  { title: "موجودی انبار" },
  { title: "ورودی ها" },
  { title: "خروجی" },
  { title: "قیمت" },
];
